import React from 'react';
import addressApi from '../../../api/address';
import './index.scss';
import DataGrid, {Column} from 'devextreme-react/data-grid';

const calcPrice = (data) => {
    console.log("data",data);
    var value = data.price?data.price:0;
    var curr = data?.currency?data.currency:'USD';
    var currency = addressApi.getSymbolbyCurrencyName(curr);
    return `${currency}${value}`;
}

const Products = (props) => {
    const data = props.data;
    return(
        <React.Fragment>
            <div>
                <p className={'master-detail-caption'}>SKU Details</p>
                <DataGrid
                    showBorders={true}
                    columnAutoWidth={true}
                    dataSource={data.sku}
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                >
                    <Column dataField={'sku'}/>
                    <Column dataField={'name'}/>
                    <Column dataField={'quantity'}/>
                    <Column dataField={'price'} calculateCellValue={calcPrice}/>
                </DataGrid>
            </div>
        </React.Fragment>
    )
};


const DetailComponent = (props) => {
    //console.log("props",props.data.data);
    const data = props.data.data;
    return (
        <Products className={'product'} data={data}/>
   )
}
export default DetailComponent;